import React, { useEffect, useState } from "react";
import "./dashboard.css";
import Topbar from "../components/Topbar";
import Leftbar from "../components/Leftbar";
// import { getCards, getPurchaseList } from '../Utils/utils';
import { Link } from "react-router-dom";
import { toggleLoader } from "../actions/loader";
import { connect } from "react-redux";
import { dashCounts } from "../Utils/utils";
import moment from "moment";
import { getUserData } from "../actions/userdata";

const Dashboard = (props) => {
  const [count, setCount] = useState([]);
  const [num, setNum] = useState([]);
  const [nanny, setNanny] = useState("");
  const [Doula, setDoula] = useState("");
  const [Consultant, setConsultation] = useState("");
  const [ALS, setALS] = useState("");
  const [thisMonthEarning, setThisMonthEarning] = useState("");
  const [totalCompletedBookings, setTotalCompletedBookings] = useState("");
  const [totalEarnings, setTotalEarnings] = useState("");
  const [totalThisMonthBookings, setTotalThisMonthBookings] = useState("");
  const [users, setUsers] = useState("");
  const [cards, setCards] = useState([]);
  // const [us, setsd] = useState("");
  // const total_earning_physio = physio.earnings?.reduce((total, i) => total + i.fees, 0) || 0;
  // const total_earning_nurse = Nurse.earnings?.reduce((total, i) => total + i.fees, 0) || 0;
  // const total_earning_geriatric = Geriatric.earnings?.reduce((total, i) => total + i.fees, 0) || 0;
  // const total_earning_ALS = ALS.earnings?.reduce((total, i) => total + i.fees, 0) || 0;
  const getCounts = async () => {
    var res = await dashCounts();
    if (res.status == 200) {
      setNanny(res.data.counts.Nanny);
      setDoula(res.data.counts.Doula);
      setConsultation(res.data.counts?.["Lactation"]);
      // setALS(res.data.counts?.["Assisted Living Supports"])
      // // setPhysioCount(res.data.physios)
      setThisMonthEarning(res.data.thisMonthEarnings);
      setTotalCompletedBookings(res.data.totalCompletedBookings);
      setTotalEarnings(res.data.totalEarnings);
      setTotalThisMonthBookings(res.data.totalThisMonthBookings);
      setUsers(res.data.users);
      setCards(res?.data?.counts || []);
    }
  };

  useEffect(() => {
    getCounts();
  }, []);
  return (
    <>
      <body class="g-sidenav-show  bg-gray-100">
        <div id="wrapper">
          <Leftbar />
          <main className="main-content border-radius-lg">
            <Topbar />
            <div className="header bg-primary pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <h6 className="h2 text-black d-inline-block mb-0">
                        Dashboard
                      </h6>
                      {/* <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark">
                          <li className="breadcrumb-item"><a href="#"><i className="fas fa-home" /></a></li>
                          <li className="breadcrumb-item"><a href="#">Components</a></li>
                        </ol>
                      </nav> */}
                    </div>
                  </div>

                  <div
                    className="row flex-wrap"
                    style={{ gap: "7px", paddingLeft: "15px" }}
                  >
                    <div className="stat-card-col">
                      <div className="card card-stats">
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="card-title text-uppercase text-muted mb-0">
                                Total Earning
                              </h6>
                              <span className="h2 font-weight-bold mb-0">
                                {totalEarnings}
                              </span>
                            </div>
                            <div className="col-auto">
                              <div className="icon icon-shape rounded-circle shadow">
                                <i className="fas fa-dollar-sign" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="stat-card-col">
                      <div className="card card-stats">
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="card-title text-uppercase text-muted mb-0">
                                Total Completed Bookings
                              </h6>
                              <span className="h2 font-weight-bold mb-0">
                                {totalCompletedBookings}
                              </span>
                            </div>
                            <div className="col-auto">
                              <div className="icon icon-shape rounded-circle shadow">
                                <i className="fas fa-check-circle" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="stat-card-col">
                      <div className="card card-stats" style={{ margin: 0 }}>
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="card-title text-uppercase text-muted mb-0">
                                This Month Earnings{" "}
                                <span className="font-weight-bold">
                                  ({moment(new Date()).format("MMM YYYY")})
                                </span>
                              </h6>
                              <span className="h2 font-weight-bold mb-0">
                                {thisMonthEarning}
                              </span>
                            </div>
                            <div className="col-auto">
                              <div className="icon icon-shape rounded-circle shadow">
                                <i className="fas fa-chart-line" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="stat-card-col">
                      <div className="card card-stats" style={{ margin: 0 }}>
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="card-title text-uppercase text-muted mb-0">
                                Total This Month Bookings{" "}
                                <span className="font-weight-bold">
                                  ({moment(new Date()).format("MMM YYYY")})
                                </span>
                              </h6>
                              <span className="h2 font-weight-bold mb-0">
                                {totalThisMonthBookings}
                              </span>
                            </div>
                            <div className="col-auto">
                              <div className="icon icon-shape rounded-circle shadow">
                                <i className="fas fa-calendar-alt" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="stat-card-col">
                      <div className="card card-stats" style={{ margin: 0 }}>
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="card-title text-uppercase text-muted mb-0">
                                Users
                              </h6>
                              <span className="h2 font-weight-bold mb-0">
                                {users}
                              </span>
                            </div>
                            <div className="col-auto">
                              <div className="icon icon-shape rounded-circle shadow">
                                <i className="fas fa-users" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    
                    <div className="col-xl-4 col-md-6">
                      <div className="card card-stats">
                        <div className="card-body">
                          <div className="row">
                            <div className="col">
                              <h6 className="card-title text-uppercase text-muted mb-0">Users</h6>
                              <span className="h2 font-weight-bold mb-0">{users}</span>
                            </div>
                            <div className="col-auto">
                              <div className="icon icon-shape bg-gradient-red text-white rounded-circle shadow">
                                <i className="ni ni-active-40" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div> */}
                  {cards?.length > 0 && (
                    <>
                      <h6 className="section-title">Service Categories</h6>
                      <div className="row category-grid">
                        {cards.map((val, idx) => {
                          const colorIdx = (idx % 6) + 1;
                          const iconMap = {
                            doula: "fa-hands-helping",
                            nanny: "fa-baby-carriage",
                            gynecologist: "fa-stethoscope",
                            lactation: "fa-baby",
                            "prenatal care": "fa-heartbeat",
                            "postnatal care": "fa-heart",
                            pediatrician: "fa-user-md",
                            "yoga trainer": "fa-spa",
                          };
                          const key = (val?.name || "").toLowerCase();
                          const iconClass = iconMap[key] || "fa-briefcase-medical";
                          return (
                            <div className="col-xl-6 col-md-6 category-col" key={idx}>
                              <div className={`card category-card cat-c${colorIdx}`}>
                                <div className="card-body">
                                  <div className="cat-header">
                                    <div className="cat-icon">
                                      <i className={`fas ${iconClass}`} />
                                    </div>
                                    <div>
                                      <h6 className="cat-name">{val?.name}</h6>
                                      <span className="cat-count">{val?.count} providers</span>
                                    </div>
                                  </div>
                                  <div className="cat-row">
                                    <span className="cat-row-label">
                                      <i className="fas fa-rupee-sign" />
                                      Total Earnings
                                    </span>
                                    <span className="cat-row-value">
                                      {Array.isArray(val?.earnings)
                                        ? val.earnings.reduce((t, i) => t + (i?.fees || 0), 0)
                                        : (typeof val?.earnings === "number" ? val.earnings : "—")}
                                    </span>
                                  </div>
                                  <div className="cat-row">
                                    <span className="cat-row-label">
                                      <i className="fas fa-calendar-check" />
                                      Total Bookings
                                    </span>
                                    <span className="cat-row-value">{val?.bookings}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="container-fluid mt--6">
              <div className="row my-4">
                <div className="col-lg-12 col-md-6 mb-md-0 mb-4">
                  <div className="card">
                    <div className="card-header pb-0">
                      <div className="row">
                        <div className="col-lg-6 col-7">
                          <h6>Recent Purchases List</h6>

                        </div>
                        <div className="col-lg-6 col-5 my-auto text-right">
                          <div className="dropdown float-lg-end pe-4">
                            <a className="cursor-pointer" id="dropdownTable" data-bs-toggle="dropdown" aria-expanded="false">
                              <i className="fa fa-ellipsis-v text-secondary" aria-hidden="true" />
                            </a>
                            <ul className="dropdown-menu px-2 py-3 ms-sm-n4 ms-n5" aria-labelledby="dropdownTable">
                              <li><a className="dropdown-item border-radius-md" href="#">Action</a></li>
                              <li><a className="dropdown-item border-radius-md" href="#">Another action</a></li>
                              <li><a className="dropdown-item border-radius-md" href="#">Something else here</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-body px-0 pb-2">
                      <div className="table-responsive">
                        <table className="table align-items-center mb-0">
                          <thead>
                            <tr>
                              <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Name</th>
                              <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Email</th>
                              <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Offer</th>
                              <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Status</th>
                              <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              (num.length === 0)
                                ?
                                <tr><td>No Recent Purchases.</td></tr>
                                :
                                num.map((data) => (
                                  <tr>
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div>
                                          {data.media !== null ?
                                            <img src={data.media.url} className="avatar avatar-sm mr-3" />
                                            : <img src="img2/small-logos/logo-xd.svg" className="avatar avatar-sm mr-3" />}

                                        </div>
                                        <div className="d-flex flex-column justify-content-center">
                                          {data.user !== null ?
                                            <h6 className="mb-0 text-sm">{data.user.first_name} {data.user.last_name}</h6>
                                            : ""}
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      {data.user !== null ?
                                        <span className="text-xs font-weight-bold">{data.user.email}</span>
                                        : ""}

                                    </td>
                                    <td className="align-middle text-center text-sm">
                                      <span className="text-xs font-weight-bold">{data.offer.name} </span>
                                    </td>
                                    <td className="align-middle">
                                      <div className="progress-wrapper w-75 mx-auto">
                                        <div className="progress-info">
                                          <div className="progress-percentage">
                                            <span className="text-xs font-weight-bold">{data.status}</span>
                                          </div>
                                        </div>
                                        <div className="progress">
                                          <div className="progress-bar bg-gradient-info w-60" role="progressbar" aria-valuenow={60} aria-valuemin={0} aria-valuemax={100} />
                                        </div>
                                      </div>
                                    </td>
                                    <td className="table-actions">
                                      <Link className="btn btn-light" data-toggle="tooltip" data-original-title="Edit product">
                                        <i className="fas fa-user-edit" />
                                      </Link>

                                    </td>
                                  </tr>
                                ))
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div> */}
          </main>
        </div>
      </body>
    </>
  );
};
const mapDispatchToProps = {
  toggleLoader,
  getUserData,
};
const mapStateToProps = (state) => {
  return {
    userdata: state.userdata?.userData,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
